export interface PermissionsInterface {
  name: string;
}

/**
 * Zawężenie uprawnień administratora HotelSpot (claim `adminPermission`).
 * `onlyAttraction` — tylko organizacje i atrakcje (bez zakładania atrakcji,
 * bez akcji na organizacjach, bez dzwonka w topbarze).
 * `onlySupport` — tylko zgłoszenia.
 * `onlyAdsGenerator` — pulpit i generator reklam, nic poza tym.
 * Brak wartości = pełny dostęp.
 */
export const adminPermissionsArray = ['onlyAttraction', 'onlySupport', 'onlyAdsGenerator'] as const;
export type AdminPermission = (typeof adminPermissionsArray)[number];
export const adminPermissionLabels: Record<AdminPermission, string> = {
  onlyAttraction: 'onlyAttraction — organizacje i atrakcje',
  onlySupport: 'onlySupport — tylko zgłoszenia',
  onlyAdsGenerator: 'onlyAdsGenerator — pulpit i generator reklam',
};

export interface CustomClaims {
  isAdmin?: boolean;
  isHotelspotAdmin?: boolean;
  adminPermission?: AdminPermission;
}
